
































import { IClient } from "@/models/clients";
import { IInvoice } from "@/models/invoices";
import { DataModules } from "@/store/modules/data";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    "content-header-control": () =>
      import("@/skeleton/admin/loggedIn/contentHeaderControl.vue")
  }
})
export default class ContentHeaderQuickActions extends Vue {
  public get actions() {
    return [
      {
        method: () => this.$store.dispatch("data/clients/openAddClientModal"),
        if: this.$userCan("create_client"),
        icon: "users",
        label: this.$t("_action.add_object", {
          object: (this.$t("_.client") as string).toLowerCase()
        })
      },
      {
        method: () => this.$store.dispatch("data/leads/openAddLeadModal"),
        if: this.$userCan("create_lead"),
        icon: "address-book",
        label: this.$t("_action.add_object", {
          object: (this.$t("_.lead") as string).toLowerCase()
        })
      },
      {
        method: () => this.$store.dispatch("data/contracts/startNewOrder"),
        if: this.$userCan("staff_create_order"),
        icon: "shopping-basket",
        label: this.$t("_action.add_object", {
          object: (this.$t("_.order") as string).toLowerCase()
        })
      },
      {
        method: async () => {
          const modal = await this.$store.dispatch(
            "data/clients/openSelectClientModal",
            {
              props: {
                allowGuestClientOption: true
              },
              events: {
                onSelect: (client: IClient) => {
                  this.placeNewQuickOrder(client);
                  modal.close();
                }
              }
            },
            {
              root: true
            }
          );
        },
        if: this.$userCan("staff_create_order"),
        icon: "shopping-basket",
        label: this.$t("_action.add_quick_order")
      },
      {
        method: () => this.$store.dispatch("data/tickets/openNewTicketModal"),
        if: this.$userCan("create_ticket"),
        icon: "comments",
        label: this.$t("_action.add_object", {
          object: (this.$t("_.ticket") as string).toLowerCase()
        })
      }
    ];
  }

  // Methods

  public placeNewQuickOrder(client: IClient) {
    this.$store.dispatch(`data/${DataModules.BASKETS}/openQuickOrderModal`, {
      props: {
        clientId: client.id,
        accountId: client.accounts?.[0]?.id
      },
      events: {
        success: (invoice: IInvoice) => {
          this.$router.push({
            name: "adminInvoice",
            params: {
              clientId: invoice.client_id,
              invoiceId: invoice.id
            }
          });
        }
      }
    });
  }
}
